// extracted by mini-css-extract-plugin
module.exports = {"button":"_772e1b1e50--button--DsA7r"};